/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Unarchive_SuccessInputs */

const fr_vehicle_action_unarchive_success = /** @type {(inputs: Vehicle_Action_Unarchive_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce véhicule a été désarchivé avec succès.`)
};

const en_vehicle_action_unarchive_success = /** @type {(inputs: Vehicle_Action_Unarchive_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This vehicle was unarchived successfully.`)
};

/**
* | output |
* | --- |
* | "This vehicle was unarchived successfully." |
*
* @param {Vehicle_Action_Unarchive_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_unarchive_success = /** @type {((inputs?: Vehicle_Action_Unarchive_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Unarchive_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_unarchive_success(inputs)
	return en_vehicle_action_unarchive_success(inputs)
});